import React from 'react';
import { Card } from 'antd';
import { ChannelPicker } from '../../ChannelPicker';
import { ChannelCategoryEntity, ChannelEntity, ChannelFilters } from '../../../../domain';
import { Pagination } from '../../../types/Pagination';

export interface ChannelsStepProps {
  channels: ChannelEntity[];
  categories: ChannelCategoryEntity[];
  isLoading: boolean;
  pagination: Pagination;
  checkedChannels: Record<string, boolean>;
  filters: ChannelFilters;
  onCheckChannels: (checkedChannels: Record<string, boolean>) => void;
  onPageChange: (page: number, pageSize: number) => void;
  onLoadMore: () => void;
  onSelectAll: () => void;
  onFiltersChange: (filters: ChannelFilters) => void;
  onPreviewCount?: (filters: ChannelFilters) => Promise<number>;
}

const ChannelsStep: React.FC<ChannelsStepProps> = ({
  channels,
  categories,
  isLoading,
  pagination,
  checkedChannels,
  filters,
  onCheckChannels,
  onPageChange,
  onLoadMore,
  onSelectAll,
  onFiltersChange,
  onPreviewCount,
}) => (
  <Card style={{ width: '100%' }}>
    <ChannelPicker
      channels={channels}
      categories={categories}
      isLoading={isLoading}
      pagination={pagination}
      filters={filters}
      selectedChannels={checkedChannels}
      mode="multiple"
      onFiltersChange={onFiltersChange}
      onSelectionChange={onCheckChannels}
      onPageChange={onPageChange}
      onLoadMore={onLoadMore}
      onSelectAll={onSelectAll}
      onPreviewCount={onPreviewCount}
    />
  </Card>
);

export default ChannelsStep;
